<template>
    <div class="student__closed row justify-content-center align-items-center">
        <div class="col-11 col-lg-6">
            <div class="student__closed-header">
                <div class="student__closed-logo">
                    <img src="../../assets/icons/icon-128x128.png" alt="Opt-Outs Logo">
                </div>
                Opt-Outs
            </div>
            <div class="student__closed-subheader">
                <!-- The opt-out form is closed! If there are any questions or concerns, please email <a
                    href="mailto:studentfinance@kings.uwo.ca">studentfinance@kings.uwo.ca</a> -->
                
                Opt-Out form has moved to <a :href="sfsportallink">Student Financial Services Portal (sfs-portal)</a>. If there are any questions or concerns, please email <a
                    href="mailto:studentfinance@kings.uwo.ca">studentfinance@kings.uwo.ca</a>
            </div>
            <a :href="sfsportallink" class="btn btn-default">Student Financial Services Portal</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'student-closed',
    data() {
        return {
            studentLink: '',
            sfsportallink: "https://"+location.hostname+"/sfs-portal"
        }
    },
    created() {
        // Generate redirect URL to Student Portal
        let URL = 'https://HOSTNAME/cgi-bin/mkvn/app.pl?student';
        URL = URL.replace("HOSTNAME", location.hostname);

        // Set student portal URL
        this.studentLink = URL;
    }
}
</script>

<style scoped>
.student__closed {
    background: url('../../assets/background/student.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    color: #333;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    margin: 0;
    text-align: center;
}

.student__closed-header {
    font-size: 2rem;
    font-weight: bold;
    letter-spacing: 2px;
    line-height: 1.2;
    text-transform: uppercase;
}

.student__closed-logo {
    margin-bottom: 1rem;
}

.student__closed-logo img {
    height: 64px;
}

.student__closed-subheader {
    font-size: 1.25rem;
    line-height: 1.2;
    padding-bottom: 2rem;
    padding-top: 1rem;
    word-break: break-word;
}

@media (max-width: 767.98px) {
    .student__closed-info {
        padding: 15px;
    }
}
</style>
